import { Controller } from 'stimulus';

import AllocationOverTimeGraph, {
  AllocationOverTimeGraphOptions,
  DataPoint,
} from '../graphs/allocation-over-time-graph';

export default class extends Controller {
  static targets = ['svg'];

  svgTarget: SVGElement;

  resizeListener: () => void;

  connect() {
    this.draw();
    this.connectResizeListener();
  }

  disconnect() {
    this.disconnectResizeListener();
  }

  draw() {
    const chart = new AllocationOverTimeGraph(this.svgTarget, this.graphOptions);
    chart.draw();
  }

  connectResizeListener() {
    this.resizeListener = this.draw.bind(this);
    window.addEventListener('resize', this.resizeListener);
  }

  disconnectResizeListener() {
    window.removeEventListener('resize', this.resizeListener);
  }

  get graphOptions(): AllocationOverTimeGraphOptions {
    return {
      allocationByDate: JSON.parse(this.data.get('allocation-by-date') || '[]') as DataPoint[],
    };
  }
}
